import React from 'react';
import { Breadcrumbs, Typography, Link } from '@material-ui/core';
import './NavBar.scss';

const NavBar = (props) => {
  const { noBreadCrumb, currentRouteName = '', breadcrumbsPath = [] } = props;
  return (
    <>
      <div className="navBar">
        <h3>{props.data}</h3>
      </div>
      {!noBreadCrumb ? (
        <div className="wrap_breadcum">
          <Breadcrumbs aria-label="breadcrumb">
            {breadcrumbsPath.length > 0 && typeof breadcrumbsPath !== 'string' ? (
              breadcrumbsPath.map((item, index) => {
                return (
                  <div key={index}>
                    {item.link ? (
                      <Link key={index} className="active_link" href={item.link ? item.link : '/'}>
                        {item.name}
                      </Link>
                    ) : (
                      <p key={index} className="active_link">
                        {item.name}
                      </p>
                    )}
                  </div>
                );
              })
            ) : (
              <></>
            )}
            <Typography className="bredcum_link">{currentRouteName}</Typography>
          </Breadcrumbs>
        </div>
      ) : null}
    </>
  );
};
export default NavBar;

